import { render, staticRenderFns } from "./RFID_V2.vue?vue&type=template&id=6d47ac4e"
import script from "./RFID_V2.vue?vue&type=script&lang=js"
export * from "./RFID_V2.vue?vue&type=script&lang=js"
import style0 from "./RFID_V2.vue?vue&type=style&index=0&id=6d47ac4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports